/**
 * Shared types for Santinho templates
 */

import { TenantPublicConfig } from '@/types/tenant.types';

export interface SantinhoTemplateProps {
  tenant: TenantPublicConfig;
}

// Helper to format mandate display
export function formatMandate(mandate: {
  position: string;
  year: number;
  location: string;
}): string {
  return `${mandate.position} - ${mandate.location} (${mandate.year})`;
}

// Check if social links exist
export function hasSocialLinks(links: TenantPublicConfig['publicPage']['socialLinks']): boolean {
  return Object.values(links).some((v) => !!v);
}
